export default [
  {
    path: '/sicapapexterno/FilaProcessamento',
    name: 'filaprocessamento',
    meta: {
      showNavbar: true,
      showDashboard: true,
      icon: 'list-nested', 
      title: 'Fila de Processamento',
      label: 'Fila de Processamento'
    },
    component: () => import(/* webpackChunkName: "FilaProcessamento" */ './pages/FilaProcessamento'),
  },
  {
    path: '/sicapapexterno/AcompanhamentoRemessas2021',
    name: 'acompanhamentoRemessas2021',
    meta: {
        showNavbar: false,
        showDashboard: false,
        icon: 'layout-text-window-reverse',
        title: 'Acompanhamento de Remessas (2021)',
        label: 'Acompanhamento de Remessas (2021)'
    },
    beforeEnter() {
       location.href = 'https://app.tce.to.gov.br/sicap/ap/externo/app/index.php' 
    }
  }
]
